export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';

export const GET_RI_COMPANY_LIST = 'GET_RI_COMPANY_LIST';
export const GET_RI_COMPANY_LIST_SUCCESS = 'GET_RI_COMPANY_LIST_SUCCESS';
export const GET_RI_COMPANY_LIST_ERROR = 'GET_RI_COMPANY_LIST_ERROR';
